export function sum(input: Array<string | number | null | undefined>) {
  let value = 0;
  input.forEach((inputValue) => {
    value += Number(inputValue);
  });
  return value;
}
